import React from 'react';
export const codeSvg = () => {
    return (
        <svg width="24" height="19" viewBox="0 0 24 19" fill="none">
            <path
                d="M2.18014 9.87975L5.87014 13.5097H3.57014L-0.109863 9.87975L3.57014 6.23975H5.87014L2.18014 9.87975Z"
                fill="#565671"/>
            <path d="M9.09033 18.4498L13.4203 0.549805H15.2303L10.8803 18.4498H9.09033Z" fill="#565671"/>
            <path d="M18.1304 13.5097L21.8204 9.87975L18.1304 6.23975H20.4304L24.1104 9.87975L20.4304 13.5097H18.1304Z"
                  fill="#565671"/>
        </svg>
    )
}